import { contactUsConstants } from "../MyAccount/myaccount.constants";

const ypoErrors = [
    {
        id: 1,
        errorType: 'LmsError',
        error: `<h1>You do not have the appropriate permissions to access this page. If you have reached this page in error, please contact your Administrator <a href="mailto:concierge@ypo.org?">concierge@ypo.org</a></h1>`,
    },
    {
        id: 2,
        errorType: 'generalError',
        error: `<h1>You do not have the appropriate permissions to access this page. If you have reached this page in error, please contact us at <a href="mailto:learning@ypo.org?">${contactUsConstants.SUPPORT_EMAIL}</a></h1>`,
    },
];

export const getYpoErrorData = (idNumber) => {
    let errorData = null;
    if (idNumber) {
      errorData = ypoErrors.find(error => error.id === idNumber);
    }
    return errorData && errorData.error ? errorData.error : null;
};

